import React from 'react';
import { Modal } from 'rsuite';
import { AllegroResponsiblePerson } from '../../../../api/allegro/responsibleperson/responsiblePersonTypes';
import EshopSetupAllegroResponsiblePersonEdit from './EshopSetupAllegroResponsiblePersonEdit';

const EDIT_TITLE = 'Edit responsible person';
const CREATE_TITLE = 'Create responsible person';

interface Props {
  isOpen: boolean;
  marketplaceCode: string;
  responsiblePerson?: AllegroResponsiblePerson;
  onClose: () => void;
  onSaved: () => void;
}

export default function EshopSetupAllegroResponsiblePersonEditModal({
  isOpen,
  marketplaceCode,
  responsiblePerson,
  onClose,
  onSaved,
}: Props): JSX.Element {
  const title = responsiblePerson ? EDIT_TITLE : CREATE_TITLE;

  return (
    <Modal
      open={isOpen}
      onClose={() => onClose()}
      backdrop="static"
      overflow
    >
      <Modal.Header>
        <Modal.Title>
          {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <EshopSetupAllegroResponsiblePersonEdit
          marketplaceCode={marketplaceCode}
          responsiblePerson={responsiblePerson}
          onCancel={() => onClose()}
          onSaved={() => onSaved()}
        />
      </Modal.Body>
    </Modal>
  );
}

EshopSetupAllegroResponsiblePersonEditModal.defaultProps = {
  responsiblePerson: undefined,
};
